import { useCallback, useState, useEffect, useRef } from 'react';

import { ScrollbarHooksProps } from './Scrollbar.d';
import { getBarPosition } from './Scrollbar.helpers';

export const useScrollbar = ({ onScroll, scrollRef }: ScrollbarHooksProps) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [barPosition, setBarPosition] = useState(0);
  const handleBarRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    setScrollPosition(scrollRef?.current?.scrollLeft);

    if (onScroll) {
      onScroll();
    }
  }, [scrollRef, onScroll]);

  useEffect(() => {
    if (scrollRef) {
      const scrollRefCurrent = scrollRef?.current;

      scrollRefCurrent?.addEventListener('scroll', handleScroll);

      return () => {
        scrollRefCurrent?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [handleScroll, scrollRef]);

  useEffect(() => {
    if (scrollRef && handleBarRef?.current) {
      const scrollWidth = (handleBarRef?.current?.children || [])[0]?.clientWidth;
      const updatedBarPosition = getBarPosition({
        scrollPosition,
        scrollWidth: scrollRef?.current?.scrollWidth,
        scrollBarWidth: scrollWidth,
        offsetWidth: scrollRef?.current?.offsetWidth,
        handleBarWidth: handleBarRef?.current?.offsetWidth,
      });

      setBarPosition(updatedBarPosition);
    }
  }, [scrollPosition, scrollRef, handleBarRef]);

  return {
    barPosition,
    handleBarRef,
  };
};
